import React from 'react';
import EmptyState from '../components/EmptyState';

const DevMessagingPage = () => {
  return (
    <div className="flex flex-col gap-6 p-6">
      <header>
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50">
          Messaging & Collaboration
        </h1>
        <p className="text-sm text-slate-500">Messages, threads, and private chats</p>
      </header>
      <EmptyState message="Messaging page - Coming soon" />
    </div>
  );
};

export default DevMessagingPage;
